import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { BackAwareDialog } from './backAwareDialog';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Grow, IconButton, Typography, } from '@mui/material';
import { Close } from '@mui/icons-material';
/**
 * @function
 * Диалог для маленьких сообщений (предупреждение, согласие и т.п.)
 * ВСЕГДА ДИАЛОГ
 * @param props
 * @return ReactElement
 */
export const MessageBox = memo(function MessageBox(props) {
    const { open, onClose, children, title, closeButtonTitle, footer, isError, isWarning, isSuccess, isInfo, withoutHorizontalPadding, border_color, data_tooltip, ...rest } = props;
    const theme = useTheme();
    const color = `${isError
        ? 'error'
        : isWarning
            ? 'warning'
            : isSuccess
                ? 'success'
                : isInfo
                    ? 'info'
                    : 'transparent'}`;
    const default_color = theme.palette.mode == 'dark'
        ? color != 'transparent'
            ? `${color}.main`
            : ''
        : color != 'transparent'
            ? `${color}.light`
            : '';
    const modal_border_color = border_color || default_color;
    return (_jsx(BackAwareDialog, { open: open, onClose: onClose, sx: {
            ...theme.typography.body1,
            '& h2': {
                color: theme.palette.text.primary,
            },
            '& .MuiDialogTitle-root': {
                pb: 0,
                '& h2': {
                    color: color != 'transparent' ? `${color}.main` : '',
                },
            },
            '& .MuiDialog-paper': {
                borderTopWidth: '3px',
                borderTopStyle: 'solid',
                borderTopColor: modal_border_color,
                borderRadius: '9px',
                maxWidth: '700px',
            },
        }, TransitionComponent: Grow, ...rest, children: _jsxs(Box, { "data-tooltip": data_tooltip, children: [title != null && (_jsx(DialogTitle, { children: _jsxs(Box, { display: "flex", alignItems: "baseline", justifyContent: "space-between", children: [_jsx(Typography, { variant: "h6", children: title }), onClose != null && (_jsx(Box, { ml: 1, mr: -2, children: _jsx(IconButton, { onClick: onClose, size: "large", children: _jsx(Close, {}) }) }))] }) })), _jsx(DialogContent, { sx: {
                        px: withoutHorizontalPadding ? 0 : '',
                    }, children: children }), closeButtonTitle && footer == null && (_jsx(DialogActions, { children: _jsx(Button, { onClick: onClose, color: isError
                            ? 'error'
                            : isWarning
                                ? 'warning'
                                : isSuccess
                                    ? 'success'
                                    : isInfo
                                        ? 'info'
                                        : 'primary', children: closeButtonTitle }) })), footer != null && _jsx(DialogActions, { sx: { pb: 2 }, children: footer })] }) }));
});
